import { render, staticRenderFns } from "./ResourceShared.vue?vue&type=template&id=ea99253e&scoped=true&"
import script from "./ResourceShared.vue?vue&type=script&lang=js&"
export * from "./ResourceShared.vue?vue&type=script&lang=js&"
import style0 from "./ResourceShared.vue?vue&type=style&index=0&id=ea99253e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea99253e",
  null
  
)

export default component.exports